<template>
  <div class="input_radio">
    <input
      type="radio"
      :id="id"
      :name="name"
      :value="value"
      @change="onChange()"
      :disabled="disabled"
      :checked="checked"
      ref="radio"
    />
    <!-- @click.prevent -->
    <label
      :for="id"
      :class="{
        checked,
        disabled: disabled,
      }"
      v-html="text"
    ></label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'select',
    event: 'custom-radio',
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: '',
    },
    text: {
      type: String,
      deafult: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    select: {
      type: Number,
      default: '',
    },
  },
  computed: {
    checked() {
      return this.select == this.value;
    },
  },
  methods: {
    onChange: function () {
      this.$emit('custom-radio', this.value);
    },
  },
};
</script>

<style lang="scss">
.input_radio {
  position: relative;
  input[type='radio'] {
    /* 실제 체크박스는 화면에서 숨김 */
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    & + label {
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
    }
  }
}
</style>
